export default __webpack_public_path__ + "static/media/genxyz.b6b34e55.png";